<div class="hid-dialog">
  <div class="hid-header">
    <h2 class="hid-title" *ngIf="!tickets">Ticketing Image Details</h2>
    <h2 class="hid-title" *ngIf="tickets">Ticket Details</h2>
    <button type="button" class="hid-close" (click)="close()" aria-label="Close">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <!-- Ticket details mode - same 2-column layout as hygiene dialog -->
  <div class="hid-body" *ngIf="tickets">
    <ng-container *ngFor="let ticket of tickets">
    <!-- Left: large ticket image -->
    <div class="hid-image-col">
      <div class="hid-image-wrap">
        <ng-container *ngIf="ticket.imageUrls?.length; else noTicketImage">
          <img *ngFor="let url of ticket.imageUrls"
               [src]="url"
               alt="Ticket"
               class="hid-img">
        </ng-container>
        <ng-template #noTicketImage>
          <div class="hid-img-placeholder">
            <i class="fa fa-image"></i>
          </div>
        </ng-template>
      </div>
      <div class="hid-location">
        <span class="hid-location-item"><strong>Campus Name:</strong> {{ ticket.campusName || campusName }}</span>
        <span class="hid-location-item"><strong>Building Name:</strong> {{ ticket.buildingName }}</span>
      </div>
    </div>

    <!-- Right: ticket meta (modeled after staff details column) -->
    <div class="hid-staff-section">
      <h3 class="hid-staff-heading">Ticket Details</h3>
      <!-- <div class="hid-caption">
        <span class="hid-dept">#{{ ticket.id }} · {{ ticket.categoryName || 'Ticket' }}</span>
        <span class="hid-meta">{{ ticket.createdOn }}</span>
      </div> -->
      <div class="hid-staff-scroll">
        <div class="hid-ticket-main">
          <!-- <div class="hid-ticket-row">
            <span class="hid-ticket-label">Campus</span>
            <span class="hid-ticket-value">{{ ticket.campusName || campusName }}</span>
          </div>
          <div class="hid-ticket-row">
            <span class="hid-ticket-label">Building</span>
            <span class="hid-ticket-value">{{ ticket.buildingName }}</span>
          </div> -->
          <div class="hid-ticket-row">
            <span class="hid-ticket-label">Floor / Room</span>
            <span class="hid-ticket-value">
              {{ ticket.floorName || '' }}<ng-container *ngIf="ticket.roomNo">/{{ ticket.roomNo }}</ng-container>
            </span>
          </div>
          <div class="hid-ticket-row">
            <span class="hid-ticket-label">Created Date</span>
            <span class="hid-ticket-value">{{ ticket.createdOn }}</span>
          </div>
          <div class="hid-ticket-row" *ngIf="ticket.createdBy">
            <span class="hid-ticket-label">Created By</span>
            <span class="hid-ticket-value">{{ ticket.createdBy }}</span>
          </div>
          <div class="hid-ticket-row" *ngIf="ticket.createdByDesignation">
            <span class="hid-ticket-label">Designation</span>
            <span class="hid-ticket-value">{{ ticket.createdByDesignation }}</span>
          </div>
          <div class="hid-ticket-row" *ngIf="ticket.createdByMobile">
            <span class="hid-ticket-label">Contact No.</span>
            <span class="hid-ticket-value">{{ ticket.createdByMobile }}</span>
          </div>
          <div class="hid-ticket-row">
            <span class="hid-ticket-label">Issue Type</span>
            <span class="hid-ticket-value">{{ ticket.categoryName || 'Ticket' }}</span>
          </div>
          <div class="hid-ticket-row" *ngIf="ticket.reason">
            <span class="hid-ticket-label">Reason</span>
            <span class="hid-ticket-value">{{ ticket.reason }}</span>
          </div>
          <div class="hid-ticket-row" *ngIf="ticket.remarks">
            <span class="hid-ticket-label">Description</span>
            <span class="hid-ticket-value">{{ ticket.remarks }}</span>
          </div>
          <div class="hid-ticket-row">
            <span class="hid-ticket-label">Assigned To</span>
            <span class="hid-ticket-value">{{ ticket.assignedTo || '—' }}</span>
          </div>
          <div class="hid-ticket-row">
            <span class="hid-ticket-label">Priority</span>
            <span class="hid-ticket-value">{{ (ticket.priority || 'N/A') | titlecase }}</span>
          </div>
          <div class="hid-ticket-row">
            <span class="hid-ticket-label">Status</span>
            <span class="hid-ticket-value">{{ (ticket.status || 'N/A') | titlecase }}</span>
          </div>
        </div>
      </div>
    </div>
    </ng-container>
  </div>

  <!-- Hygiene image mode (existing) -->
  <div class="hid-body" *ngIf="!tickets">
    <div class="hid-image-col">
      <div class="hid-image-wrap">
        <img *ngIf="picture.fileName" [src]="picture.fileName" [alt]="picture.departmentName" class="hid-img">
        <div *ngIf="!picture.fileName" class="hid-img-placeholder">
          <i class="fa fa-image"></i>
        </div>
      </div>
      <div class="hid-location" *ngIf="campusName || buildingName">
        <span *ngIf="campusName" class="hid-location-item"><strong>Campus:</strong> {{ campusName }}</span>
        <span *ngIf="buildingName" class="hid-location-item"><strong>Building:</strong> {{ buildingName }}</span>
      </div>
    </div>
    <div class="hid-staff-section">
      <h3 class="hid-staff-heading">Staff Details</h3>
      <div class="hid-caption">
        <span class="hid-dept">{{ picture.departmentName }}</span>
        <span class="hid-meta">{{ formatHygieneTime(picture.hygieneDate) }} · {{ picture.employeeCount }} staff</span>
      </div>
      <div class="hid-staff-scroll">
        <ul *ngIf="staffList.length" class="hid-staff-list">
          <li *ngFor="let s of staffList" class="hid-staff-item">
            <span class="hid-staff-name">{{ s.staffName ?? '—' }}</span>
            <span class="hid-staff-aadhar">Aadhar: {{ s.aadharNo ?? '—' }}</span>
          </li>
        </ul>
        <p *ngIf="staffList.length === 0" class="hid-empty">No staff details in this record.</p>
      </div>
    </div>
  </div>
</div>
